import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './Header.css';

interface HeaderProps {
  onCartClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onCartClick }) => {
  const { getTotalItems } = useCart();
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Chỉ áp dụng cho mobile (màn hình <= 768px)
      if (window.innerWidth <= 768) {
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
          // Scroll xuống và đã scroll quá 100px
          setIsScrolled(true);
        } else {
          // Scroll lên
          setIsScrolled(false);
        }
      } else {
        // Desktop: luôn hiển thị
        setIsScrolled(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <header className={`header ${isScrolled ? 'header-hidden' : ''}`}>
      <div className="container">
        <div className="header-top">
          <div className="logo">
            <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
              <img src="/Pink Y2k Flower Cute Streetwear Logo.png" alt="Mơ Nails" className="logo-image" />
            </Link>
          </div>
          <div className="header-actions">
            <a 
              href="#cart" 
              className="cart"
              onClick={(e) => {
                e.preventDefault();
                if (onCartClick) {
                  onCartClick();
                }
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" xmlSpace="preserve" className="cart-icon">
                <g>
                  <path d="M94.4,22.7c-0.4-0.1-0.8-0.2-1.2-0.2H77.5h-7.8H46.1h-7.8h-9.8L25,12.8c-2.1-6-7.8-10-14.2-9.9H6.8c-2.2,0-3.9,1.8-3.9,3.9
                    s1.8,3.9,3.9,3.9h3.9c3,0,5.7,1.9,6.7,4.7l15.2,42.4c1.7,4.7,6.1,7.8,11.1,7.8h32c5.1,0,9.6-3.2,11.2-8l10-30
                    C97.6,25.6,96.5,23.4,94.4,22.7z"></path>
                  <circle cx="42.1" cy="85.3" r="11.8"></circle>
                  <circle cx="73.5" cy="85.3" r="11.8"></circle>
                </g>
              </svg>
              <span className="icon__fallback-text">Your Cart</span>
              <div className="site-header__cart-count">
                <span className="count CartCount">{getTotalItems()}</span>
                <span className="cart-words">{getTotalItems() === 1 ? 'item' : 'items'}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

